<template>
    <div class="size-full rounded-lg border flex flex-col justify-between p-[12px]">
        <div><h2 class="flex font-extralight items-center gap-x-2">Taux d'absentéisme <Info :size="15" strokeWidth="1.3"/></h2></div>
        <div class="h-[310px] w-full">
            <apexchart :options="options" :series="series" width="100%" height="310px"></apexchart>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TauxAbsenteisme',
    components: {},
    props:['serie'],
    mounted(){
        this.series = this.transformMonthlyData(this.serie).series;
        console.log("data format ===> ",this.series[2].data)
    },
    data(){
        return {
            series: [],
            options:{
                chart: {
                    stacked: false,
                    animations: {
                        enabled: false
                    },
                    toolbar: {  
                    show: false
                    },
                },
                colors: ['#5589f6', '#099556', '#ee4636'], 
                stroke: {
                    width: [0, 0, 3],
                    curve: 'smooth'
                },
                fill:{
                    opacity: [1, 1, 1],
                    type: 'solid'
                },
            xaxis: {
                categories: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin','Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
                labels: {
                    style: {
                            fontWeight: 200,
                            colors: ['#000000']
                        },
                }
            },
            dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:true
                },
            }
        }
    },
    methods:{
        transformMonthlyData(data) {
            if (!data || data.length === 0) {
                return { series: [], labels: [] };
            }

            const expectedData = [];
            const actualData = [];
            const differenceData = [];
            const monthLabels = [];

            const seriesKeys = [
                { key: 'expected', name: 'Prévu (Expected)', type: 'bar' },
                { key: 'actual', name: 'Réel (Actual)', type: 'bar' },
                { key: 'difference', name: 'Différence', type: 'line' }
            ];

            data.forEach(item => {
                monthLabels.push(item.month);
                expectedData.push(item.expected);
                actualData.push(item.actual);
                differenceData.push(item.difference);
            });
            const series = [
                {
                    name: seriesKeys[0].name,
                    type: seriesKeys[0].type,
                    data: expectedData
                },
                {
                    name: seriesKeys[1].name,
                    type: seriesKeys[1].type,
                    data: actualData
                },
                {
                    name: seriesKeys[2].name,
                    type: seriesKeys[2].type,
                    data: differenceData
                }
            ];

            return { series, labels: monthLabels };
        }
    }
}
</script>